// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__pGz4P","content":"GlobalSearch_content__3cSq0"};